import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';

import { ConsumeService } from '../../../../../app/services/consume.service';
import { VoiceConsumeService } from '../../../../../app/services/voice.consume.service';
import { AuthenticationService } from '../../../../../app/services/authentication.service';
import { PaginatedResult } from '../../../../models/paginatedResult.model';
import { LoadingComponent } from "../../modalLoading/content.component";
import { BindComponentService } from '../../../../utils/bind.component.service';
/**
 * @version $Id: content.component.ts 70114 2017-11-17 20:07:29Z diego.s.bastos $
 */
@Component({
  selector: 'moveConsume',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class MoveLineConsumeComponent {

  private static readonly GROUPS_FETCH_SIZE: number = 10;
  @Input() selectedGroup: DataPackGroup;
  @Input() count: any;  
  @Input() lines: Map<string, DataPackLine>;
  @Input() groups: Array<DataPackGroup>;
  @Input() isConsumeVoice: boolean;
  @Input() hasOverBalanceMonetaryVoice: boolean;
  @Input() hasHibridService: boolean;  
  @Input() paginationSearch: any;


  private pageSize: number = MoveLineConsumeComponent.GROUPS_FETCH_SIZE;
  private destinationGroupId: string;
  private saving: boolean = false;
  private isData:boolean;
  private pageBegin: number = 1;
  private pageEnd: number = this.pageSize;
  private page: any;

  constructor(private authenticationService: AuthenticationService,
    private voiceConsumeService: VoiceConsumeService,
    private activeModal: NgbActiveModal,
    private consumeService: ConsumeService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private bindComponent: BindComponentService) {}

  private close() {
    this.activeModal.dismiss();
  }

  private setDestinyGroupId(id: string) {
    this.destinationGroupId = id;
  }


  ngOnInit() {
    this.page = 0;
    let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.isData = data['isData'];
  }

 
  private move() {
    
    if (!this.destinationGroupId) {
      this.alertService.warn('Selecione um grupo de destino');
      return;
    }
    this.saving = true;
    let payload: any = {};
    payload.action = 'moveLines';
    payload.validate = '1';
    payload.sourceGroup = {id: this.selectedGroup.id};
    payload.destinationGroup = {id: this.destinationGroupId};
    payload.lines = [];
    payload.isData = this.isData;
    payload.hasHibridService = this.hasHibridService;
    payload.hasOverBalanceMonetaryVoice = this.hasOverBalanceMonetaryVoice;


    for(let entry of Array.from(this.lines.entries())) {
      payload.lines.push(entry[1]);
    }
    if(this.isConsumeVoice){
      this.saveVoice(payload);
    }else{
      this.saveData(payload);
    }
   
  }
  public saveData(payload: any){
    this.consumeService.save(payload).subscribe(
      data => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.success(data['result']);
      },
      err => {
        if (err.question === true) {
          this.saving = false;
          this.activeModal.close({message: err.result, destinationGroupId: this.destinationGroupId, question: true});
        } else {
          this.saving = false;
          this.activeModal.close();
          this.alertService.error(err.result, err);
        }
      }
    );
  }
  public resultSucess(data:any){
    this.alertService.success(data['result']);
    this.saving = false;
    this.activeModal.close();
  }

  public saveVoice(payload: any){
    this.voiceConsumeService.save(payload).subscribe(
      data => {
       this.resultSucess(data);
      },
      err => {
        if (err.question == true) {
          this.saving = false;
          this.activeModal.close({message: err.result, destinationGroupId: this.destinationGroupId, question: true});
        } else {
          this.saving = false;
          this.activeModal.close();
          this.alertService.error(err.result, err);
        }
      }
    );
  }

  public isOverBalanceMonetaryVoice(){    
    return this.hasOverBalanceMonetaryVoice;
  }

  public isHibrid(){    
    return this.hasHibridService;
  }

  loadPage(pag: number) {
    this.openModalLoading();
   
    this.pageBegin = pag;
    let payload:any = {
      startRow : this.pageBegin,
      fetchSize : this.pageSize,
      action:'getGroupMoveLines',
      group:this.selectedGroup,
      hasOverBalanceMonetaryVoice:this.hasOverBalanceMonetaryVoice,
      hasHibridService:this.hasHibridService
    }
    if(this.isConsumeVoice){
     
      this.voiceConsumeService.getGroupMoveLines(payload).subscribe(
        data => {

            this.groups = (data['groupList'] as Array<DataPackGroup>).filter(group => group.is5GPortifolio == 0);
            this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        },
        err => {
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        });
    }else{
      this.consumeService.getGroupMoveLines(payload).subscribe(
        data => {
            this.groups =  data['groupList'];
            this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        },
        err => {
          this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        });
    }
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }






}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/move/content.component.ts